
import React, { useState, useEffect } from 'react'

const Addappreciation = () => {
  const [clientImage, setClientImage] = useState(null)
  const [appreciationImage, setAppreciationImage] = useState(null)
  const [clientPreviewUrl, setClientPreviewUrl] = useState(null)
  const [appreciationPreviewUrl, setAppreciationPreviewUrl] = useState(null)
  const [uploadedImages, setUploadedImages] = useState([])

  const [formData, setFormData] = useState({
    name: '',
    role: '',
    description: '',
    companyName: '',
    companyDescription: '',
  })

  useEffect(() => {
    fetchImages()
  }, [])

  const fetchImages = async () => {
    try {
      const response = await fetch('https://blog-backend-ivfv.onrender.com/api/employee-appreciations')
      if (response.ok) {
        const data = await response.json()
        setUploadedImages(data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleImageChange = (e, type) => {
    const file = e.target.files[0]
    const reader = new FileReader()

    if (file) {
      reader.onloadend = () => {
        if (type === 'client') {
          setClientImage(file)
          setClientPreviewUrl(reader.result)
        } else {
          setAppreciationImage(file)
          setAppreciationPreviewUrl(reader.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const { name, role, description, companyName, companyDescription } = formData

    if (!clientImage || !appreciationImage || !name || !role || !description || !companyName || !companyDescription) {
      alert('Please fill in all fields and select both images.')
      return
    }

    const data = new FormData()
    data.append('clientImage', clientImage)
    data.append('appreciationImage', appreciationImage)
    data.append('name', name)
    data.append('role', role)
    data.append('description', description)
    data.append('companyName', companyName)
    data.append('companyDescription', companyDescription)

    try {
      const res = await fetch('https://blog-backend-ivfv.onrender.com/aupload-image', {
        method: 'POST',
        body: data,
      })

      if (res.ok) {
        alert('Images uploaded successfully!')
        setClientImage(null)
        setAppreciationImage(null)
        setClientPreviewUrl(null)
        setAppreciationPreviewUrl(null)
        setFormData({
          name: '',
          role: '',
          description: '',
          companyName: '',
          companyDescription: '',
        })
        fetchImages()
      } else {
        alert('Failed to upload images.')
      }
    } catch (error) {
      alert('Error uploading images.')
    }
  }

  const handleDelete = async (id) => {
    if (!id) {
      alert("Invalid ID");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this image?")) return;

    try {
      const res = await fetch(`https://blog-backend-ivfv.onrender.com/api/employee-appreciations/${id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        alert("Image deleted successfully");
        setUploadedImages((imgs) => imgs.filter((img) => img._id !== id));
      } else {
        alert("Failed to delete image");
      }
    } catch (error) {
      alert("Error deleting image");
    }
  };


  return (
    <div className="d-flex flex-column align-items-center bg-light py-5" style={{ minHeight: '100vh', overflowY: 'auto' }}>
      <div className="card shadow p-4 mb-5" style={{ maxWidth: '800px', width: '100%' }}>
        <h3 className="mb-4 text-center text-primary">Upload Employee Appreciation</h3>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Name</label>
              <input type="text" className="form-control" name="name" value={formData.name} onChange={handleInputChange} required />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Role</label>
              <input type="text" className="form-control" name="role" value={formData.role} onChange={handleInputChange} required />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Description</label>
              <textarea className="form-control" name="description" rows="3" value={formData.description} onChange={handleInputChange} required />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Company Name</label>
              <input type="text" className="form-control" name="companyName" value={formData.companyName} onChange={handleInputChange} required />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Company Description</label>
              <textarea className="form-control" name="companyDescription" rows="2" value={formData.companyDescription} onChange={handleInputChange} required />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Client Image</label>
              <input type="file" accept="image/*" className="form-control" onChange={(e) => handleImageChange(e, 'client')} />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Appreciation Image</label>
              <input type="file" accept="image/*" className="form-control" onChange={(e) => handleImageChange(e, 'appreciation')} />
            </div>
          </div>

          {/* Preview Area */}
          <div className="mb-4 d-flex justify-content-center gap-3 flex-wrap">
            {clientPreviewUrl && (
              <img src={clientPreviewUrl} alt="Client Preview" className="img-thumbnail" style={{ maxHeight: '150px' }} />
            )}
            {appreciationPreviewUrl && (
              <img src={appreciationPreviewUrl} alt="Appreciation Preview" className="img-thumbnail" style={{ maxHeight: '150px' }} />
            )}
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={!clientImage || !appreciationImage}>
            Save Appreciation
          </button>
        </form>
      </div>


      {/* Uploaded Entries */}
      <div className="container px-4" style={{ maxWidth: '1000px' }}>
        <h4 className="mb-4 text-primary text-center">Uploaded Appreciations</h4>
        {uploadedImages.length === 0 ? (
          <p className="text-center text-muted">No entries uploaded yet.</p>
        ) : (
          <div className="row g-4">
            {uploadedImages.map((img) => (
              <div key={img._id} className="col-md-4">
                <div className="card position-relative h-100 shadow-sm">
                  <div className="p-2 border-bottom bg-light text-center">
                    <strong>{img.name}</strong><br />
                    <small className="text-muted">{img.role}</small>
                  </div>

                  <div className="p-2">
                    <img
                      src={`https://blog-backend-ivfv.onrender.com${img.clientImageUrl}`}
                      alt="Client"
                      className="img-fluid rounded mb-2"
                      style={{ height: '130px', objectFit: 'cover', width: '100%' }}
                    />
                    <img
                      src={`https://blog-backend-ivfv.onrender.com${img.appreciationImageUrl}`}
                      alt="Appreciation"
                      className="img-fluid rounded"
                      style={{ height: '130px', objectFit: 'cover', width: '100%' }}
                    />
                    <p className="mt-2 small">{img.description}</p>
                    <p className="mb-1"><strong>{img.companyName}</strong></p>
                    <p className="small text-muted">{img.companyDescription}</p>
                  </div>

                  <button
                    onClick={() => handleDelete(img.id)}
                    className="btn btn-sm btn-danger position-absolute"
                    style={{ top: '10px', right: '10px' }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

  )
}

export default Addappreciation
